/* eslint-disable react-hooks/exhaustive-deps */
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './SecuritySectionEditMode.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { InputText, PasswordChecker, ErrorAlert } from 'ui_kit_qmd'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../utils/errormessages'
import AccountSettingsPageTitle from '../../AccountSettingsPageTitle/AccountSettingsPageTitle'
import errorIcon from '../../../../images/common/error-icon.svg'
import {
  setAccountSettingsError,
  setPasswordErrorMessage,
} from '../../../../store/accountSettings/AccountSettingsActions'
import { editProviderPassword } from '../../../../store/accountSettings/AccountSettingsThunk'
import { getTabId } from '../../../../utils/common'

const commontInputContainerStyle = {
  marginBottom: 48,
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const SecuritySectionEditMode = ({ toggleIsEditMode }) => {
  const dispatch = useDispatch()

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const passwordErrorMessage = useSelector((state) => state.accountSettings.passwordErrorMessage)

  const [currentPasswordValue, setCurrentPasswordValue] = useState('')
  const [newPasswordValue, setNewPasswordValue] = useState('')
  const [confirmPasswordValue, setConfirmPasswordValue] = useState('')
  const [toastErrorMessage, setToastErrorMessage] = useState('')
  const [currentPasswordErrorValue, setCurrentPasswordErrorValue] = useState('')
  const [newPasswordErrorValue, setNewPasswordErrorValue] = useState('')
  const [confirmPasswordErrorValue, setConfirmPasswordErrorValue] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false)
  const [isCheckerStarted, setIsCheckerStarted] = useState(false)
  const [isCurrentPasswordError, setIsCurrentPasswordError] = useState(false)
  const [isNewPasswordError, setIsNewPasswordError] = useState(false)
  const [isConfirmPasswordError, setIsConfirmPasswordError] = useState(false)
  const [isSamePasswordsError, setIsSamePasswordsError] = useState(false)
  const [isResetValue, setIsResetValue] = useState(false)
  const tabId = getTabId()

  useEffect(
    () => () => {
      dispatch(setPasswordErrorMessage(''))
    },
    [],
  )
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const checkIsValidValue = (value) => value.match(/^(?=.{10,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$/)

  useEffect(() => {
    const isValuesReset = !currentPasswordValue && !newPasswordValue && !confirmPasswordValue
    if (isResetValue && isValuesReset) {
      toggleIsEditMode(false)
    }
  }, [isResetValue, currentPasswordValue, newPasswordValue, confirmPasswordValue])

  useEffect(() => {
    if (passwordErrorMessage === getUserFriendlyErrorMessage(errorCodes.CURRENT_PASSWORD_IS_INCORRECT)) {
      setIsCurrentPasswordError(true)
      setCurrentPasswordErrorValue(passwordErrorMessage)
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    }
    if (passwordErrorMessage === getUserFriendlyErrorMessage(errorCodes.PASSWORD_MUST_BE_DIFFERENT)) {
      setIsNewPasswordError(true)
      setNewPasswordErrorValue(passwordErrorMessage)
      setIsConfirmPasswordError(true)
      setIsSamePasswordsError(true)
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    }
  }, [passwordErrorMessage])

  useEffect(() => {
    if (toastErrorMessage) {
      setTimeout(() => {
        setToastErrorMessage('')
      }, 3500)
    }
  }, [toastErrorMessage])
  const onSetNotValidInputsErrors = () => {
    if (!isPasswordValid) {
      setIsNewPasswordError(true)
      setIsConfirmPasswordError(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setNewPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'password'))
      setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
    }
    if (!checkIsValidValue(confirmPasswordValue)) {
      setIsConfirmPasswordError(true)
    }
    dispatch(setPasswordErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)))
  }

  const onSetNotConfirmedPasswordErrors = () => {
    setIsNewPasswordError(true)
    setIsConfirmPasswordError(true)
    setConfirmPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.PASSWORDS_DO_NOT_MATCH))
    setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
  }

  const sendNewPassword = () => {
    setIsCurrentPasswordError(false)
    setIsNewPasswordError(false)
    setIsConfirmPasswordError(false)
    dispatch(setPasswordErrorMessage(''))
    dispatch(setAccountSettingsError(''))
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      editProviderPassword({
        CurrentPassword: currentPasswordValue,
        NewPassword: newPasswordValue,
        tabId,
      }),
    )
  }
  const onSetEmptyInputsErrors = () => {
    if (!currentPasswordValue) {
      setIsCurrentPasswordError(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setCurrentPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Current password'))
    }
    if (!newPasswordValue) {
      setIsNewPasswordError(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setNewPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'New password'))
    }
    if (!confirmPasswordValue) {
      setIsConfirmPasswordError(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setConfirmPasswordErrorValue(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Confirm new password'))
    }
    setToastErrorMessage(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
  }

  const onCancelBtnClicked = () => {
    setIsResetValue(true)
  }

  const onSafeBtnClicked = () => {
    setIsCurrentPasswordError(false)
    setIsNewPasswordError(false)
    setIsConfirmPasswordError(false)
    setCurrentPasswordErrorValue('')
    setNewPasswordErrorValue('')
    setConfirmPasswordErrorValue('')

    const isFilledInputs = currentPasswordValue && newPasswordValue && confirmPasswordValue

    const isConfirmatedPassword = newPasswordValue === confirmPasswordValue

    if (!isCheckerStarted) {
      setIsCheckerStarted(true)
    }
    if (!isFilledInputs) {
      onSetEmptyInputsErrors()
      return
    }
    if (!isPasswordValid) {
      onSetNotValidInputsErrors()
      return
    }
    if (!isConfirmatedPassword) {
      onSetNotConfirmedPasswordErrors()
      return
    }

    sendNewPassword()
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeInputValue = (type) => (value) => {
    dispatch(setPasswordErrorMessage(''))
    if (isSamePasswordsError) {
      setIsCurrentPasswordError(false)
      setIsSamePasswordsError(false)
    }
    switch (type) {
      case 'currentPassword':
        setIsCurrentPasswordError(false)
        setCurrentPasswordErrorValue('')
        setCurrentPasswordValue(value)
        break
      case 'newPassword':
        setIsNewPasswordError(false)
        setNewPasswordErrorValue('')
        setNewPasswordValue(value)
        if (confirmPasswordErrorValue === getUserFriendlyErrorMessage(errorCodes.PASSWORDS_DO_NOT_MATCH)) {
          setConfirmPasswordErrorValue('')
        }
        break
      case 'confirmPassword':
        setIsConfirmPasswordError(false)
        setConfirmPasswordErrorValue('')
        setConfirmPasswordValue(value)
        break
      default:
        break
    }
  }

  return (
    <>
      {toastErrorMessage ?
        <div className='security-section-edit-mode-error-message'>
          <ErrorAlert
            styleContainer={{ width: 550 }}
            errorText={toastErrorMessage}
            errorImg={errorIcon}
            imgAlt='Error'
          />
        </div>
      : null}
      <AccountSettingsPageTitle
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        onSafeBtnClicked={onSafeBtnClicked}
        onCancelBtnClicked={onCancelBtnClicked}
        toggleIsEditMode={toggleIsEditMode}
        isEditMode
      />
      <div
        className={`security-section-edit-mode-password-input-wrapper ${
          isCurrentPasswordError ? 'security-section-edit-mode-password-input-wrapper-with-error' : ''
        }`}>
        <InputText
          containerStyle={commontInputContainerStyle}
          isSecure
          label='Current password*'
          setValue={onChangeInputValue('currentPassword')}
          view='providerEditPassword'
          isError={isCurrentPasswordError}
          localError={currentPasswordErrorValue}
          isResetClicked={isResetValue}
        />
      </div>
      <div
        className={`security-section-edit-mode-password-input-wrapper ${
          isNewPasswordError ? 'security-section-edit-mode-password-input-wrapper-with-error' : ''
        }`}>
        <InputText
          containerStyle={commontInputContainerStyle}
          isSecure
          label='New password*'
          setValue={onChangeInputValue('newPassword')}
          view='providerEditPassword'
          isError={isNewPasswordError}
          localError={newPasswordErrorValue}
          isResetClicked={isResetValue}
        />
      </div>
      <div
        className={`security-section-edit-mode-password-input-wrapper ${
          isConfirmPasswordError ? 'security-section-edit-mode-password-input-wrapper-with-error' : ''
        }`}>
        <InputText
          containerStyle={commontInputContainerStyle}
          isSecure
          label='Confirm new password*'
          setValue={onChangeInputValue('confirmPassword')}
          view='providerEditPassword'
          isError={isConfirmPasswordError}
          isResetClicked={isResetValue}
          localError={confirmPasswordErrorValue}
        />
      </div>
      <PasswordChecker
        passwordValue={newPasswordValue}
        started={isCheckerStarted}
        onSetValidPassword={setIsPasswordValid}
      />
    </>
  )
}
